/**
 * Shared react-query options for the admin customers list.
 *
 * The defaults are wrong for this particular query. It is the most expensive read in the product,
 * and react-query v3 ships with `staleTime: 0` and `retry: 3` whose backoff is capped at 30s — so a
 * request that takes too long and fails is re-sent three more times, roughly every 30 seconds, each
 * one as costly as the first. During the crash-loop incident that is what kept the database busy
 * long after the original page had given up.
 *
 * `staleTime` also stops a remount or a tab regaining focus from immediately re-running it, which
 * with `staleTime: 0` happened on every such event.
 */
export const customersQueryOptions = {
  // Long enough that navigating away and back, or switching tabs, reuses the cached page; short
  // enough that the list still looks live. Any mutation invalidates the key explicitly anyway.
  staleTime: 30_000,
  // One retry covers a genuine blip. Beyond that the server is either down or overloaded, and
  // re-sending this query is the least helpful thing the client can do.
  retry: 1,
};
